import { defaultGridSettings } from "@smartsuite/grid/lib/Grid.constants";
import type { GridSettings } from "@smartsuite/grid/lib/Grid.types";
import type { GridScrollOptions } from "@smartsuite/grid/lib/types";

export const automationActivityGridSettings: GridSettings = {
  ...defaultGridSettings,
  showFooter: false,
  enableColumnResizing: false,
  enableColumnReordering: false,
  enableRecordDragAndDrop: false,
};

export const automationActivityGridScrollOptions: GridScrollOptions = {
  headHeight: 33,
  footerHeight: 0,
  gutterTop: 0,
  gutterBottom: 0,
  gutterRight: -59,
  gutterLeft: 0,
  extraHeight: 0,
  extraLeftWidth: 0,
  extraRightWidth: 100,
  bufferVertical: 0,
  bufferHorizonal: 0,
  endOfListThreshold: 0,
};
